package com.kanati.shared.commerce

import kotlinx.serialization.Serializable

@Serializable
data class CreateProductRequest(
    val districtId: String,
    val schoolId: String = "",
    val name: String,
    val sku: String? = null,
    val priceAmount: Long,
    val taxable: Boolean,
    val active: Boolean = true,
)

@Serializable
data class UpdateProductRequest(
    val districtId: String,
    val schoolId: String = "",
    val name: String? = null,
    val sku: String? = null,
    val priceAmount: Long? = null,
    val taxable: Boolean? = null,
    val active: Boolean? = null,
)

@Serializable
data class ProductResponse(
    val id: String,
    val districtId: String,
    val schoolId: String = "",
    val name: String,
    val sku: String?,
    val priceAmount: Long,
    val taxable: Boolean,
    val active: Boolean,
    val createdAt: String,
    val updatedAt: String,
)
